module.exports = __webpack_public_path__ + "statics/img/banner.97779aa1.gif";